// Mock data for PREBATI website - Arabic version

export const companyInfo = {
  name: "بريباتي",
  tagline: "بريباتي تفتح الطريق للخرسانة سابقة الإجهاد الصناعية في موريتانيا.",
  phone: "43111616",
  email: "contact@prebati-mr.com",
  website: "www.prebati-mr.com",
  location: "نواكشوط - موريتانيا",
  logo: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/hcd9fosi_Logo%20complet.png"
};

export const heroContent = {
  title: "أرضيات من الخرسانة سابقة الإجهاد ومنتجات خرسانية صناعية، مصنوعة في موريتانيا",
  subtitle: "بريباتي هي أول مصنع موريتاني متخصص في إنتاج أرضيات الخرسانة سابقة الإجهاد، بترخيص من OTEP فرنسا، للمشاريع السكنية والجماعية والإدارية والصناعية.",
  intro: "بفضل عملية صناعية مثبتة ومعتمدة، تقدم بريباتي حلولاً أسرع وأكثر أماناً واقتصادية من الطرق التقليدية، مع ضمان مستوى عالٍ من الجودة والمطابقة التقنية.",
  keyPoints: [
    "عملية صناعية بترخيص OTEP فرنسا",
    "تصنيع محلي - معايير فرنسية وأوروبية",
    "أرضيات بامتداد يصل إلى 9-10 متر",
    "حلول مكيفة لمواقع البناء الموريتانية"
  ],
  backgroundImage: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/lkx7oxoy_DJI_0358.JPG"
};

export const aboutContent = {
  title: "بريباتي، صناعة في خدمة البناء الحديث",
  paragraphs: [
    "بريباتي هي شركة صناعية موريتانية متخصصة في منتجات الخرسانة، مع خبرة قوية في أرضيات الخرسانة سابقة الإجهاد.",
    "نتاج شراكة بين إيكوباتي و OTEP، تعمل بريباتي بترخيص من OTEP فرنسا، وهي تقنية مثبتة ومستخدمة دولياً منذ عقود."
  ],
  objectives: [
    "تحديث قطاع البناء في موريتانيا",
    "تقديم حلول موثوقة وتنافسية ومنتجة محلياً",
    "مرافقة مشاريع البناء بدعم تقني كامل"
  ],
  positioning: [
    { title: "مصنع صناعي", description: "لسنا موزعين - إنتاج محلي متقن" },
    { title: "مكتب دراسات متكامل", description: "مرافقة تقنية لمشاريعكم" },
    { title: "إنتاج مصنعي مراقب", description: "جودة ثابتة وموثقة" },
    { title: "دعم تقني", description: "مساعدة لمشاريع البناء الخاصة بكم" }
  ],
  image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/s393vp4d_Usine%20Haute%20Qualite%CC%81.png"
};

export const prestressedConcreteContent = {
  title: "الخرسانة سابقة الإجهاد",
  subtitle: "فهم التقنية التي تُحدث ثورة في البناء",
  sections: [
    {
      title: "ما هي الخرسانة سابقة الإجهاد؟",
      content: "الخرسانة سابقة الإجهاد هي تقنية بناء متقدمة تتضمن وضع الخرسانة تحت الضغط قبل أن تتحمل الأحمال. يتم الحصول على هذا الضغط المسبق عن طريق شد كابلات فولاذية عالية المقاومة قبل صب الخرسانة. بمجرد تصلب الخرسانة، يتم تحرير التوتر، مما ينقل ضغطاً دائماً للخرسانة."
    },
    {
      title: "لماذا يحسن الإجهاد المسبق الأداء؟",
      content: "تقاوم الخرسانة الضغط بشكل جيد جداً لكنها أقل مقاومة للشد. من خلال الإجهاد المسبق للخرسانة، نقضي أو نقلل بشكل كبير من إجهادات الشد، مما يسمح بالحصول على عناصر أكثر مقاومة، قادرة على تجاوز امتدادات أكبر بمواد أقل."
    },
    {
      title: "عملية بريباتي",
      steps: [
        "شد الكابلات الفولاذية عالية المقاومة",
        "صب الخرسانة عالية الأداء حول الكابلات المشدودة",
        "معالجة وتصلب الخرسانة المتحكم به",
        "تحرير الإجهاد المسبق - نقل الضغط للخرسانة",
        "مراقبة الجودة والتخزين"
      ]
    }
  ],
  benefits: [
    { title: "مقاومة فائقة", description: "قدرة تحمل متزايدة مقارنة بالخرسانة المسلحة التقليدية" },
    { title: "امتدادات أطول", description: "إمكانية تجاوز 9-10 أمتار دون دعم وسيط" },
    { title: "تشقق أقل", description: "الضغط المسبق يقلل بشكل جذري من مخاطر التشققات" },
    { title: "متانة أكبر", description: "مقاومة أفضل مع مرور الوقت، خاصة في المناخ الساحلي" }
  ],
  image: "https://images.unsplash.com/photo-1715656423856-622b7f911c78"
};

export const products = [
  {
    id: "planchers",
    title: "أرضيات من الخرسانة سابقة الإجهاد",
    description: "نظام الكمرات + البلاطات الخرسانية لأرضيات فعالة واقتصادية.",
    details: [
      "بلاطات متوفرة بارتفاعات 12، 16، 20 و 25 سم",
      "امتدادات محسنة بفضل حسابات مكتب الدراسات لدينا",
      "مناسبة للمباني السكنية والجماعية والصناعية"
    ],
    useCases: ["منازل فردية", "مباني جماعية", "مباني إدارية", "مباني صناعية"],
    advantages: ["سرعة التركيب", "توفير في اليد العاملة", "امتدادات حتى 10م", "جودة صناعية ثابتة"],
    image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/rzqz54vr_DJI_20260112145622_0029_D.JPG"
  },
  {
    id: "parpaings",
    title: "منتجات مضغوطة",
    description: "مجموعة واسعة من الكتل الخرسانية لجميع مشاريع البناء.",
    details: [
      "كتل مجوفة (10، 15، 20 سم)",
      "كتل للصب (20، 30، 40 سم)",
      "كتل أعمدة وسلاسل"
    ],
    useCases: ["جدران حاملة", "فواصل", "أسوار", "أساسات"],
    advantages: ["إنتاج محلي", "معايير محترمة", "اختيار واسع"],
    image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/uqxn6eua__50A7387.JPG"
  },
  {
    id: "poutres",
    title: "كمرات جاهزة",
    description: "كمرات خرسانية قياسية لاحتياجات البناء الشائعة.",
    details: [
      "أبعاد قياسية 20×20 سم",
      "أطوال متنوعة متوفرة",
      "جودة مراقبة في المصنع"
    ],
    useCases: ["هياكل حاملة", "عتبات", "سلاسل"],
    advantages: ["توفر فوري", "جودة ثابتة", "سعر تنافسي"],
    image: "https://images.unsplash.com/photo-1732636844217-5acf045486fc"
  },
  {
    id: "paves",
    title: "بلاط خرساني",
    description: "بلاط متشابك للتهيئة الخارجية.",
    details: [
      "أشكال وسماكات مختلفة",
      "مقاومة لحركة المرور",
      "تشطيبات متنوعة"
    ],
    useCases: ["طرق", "ساحات", "مواقف سيارات", "أرصفة"],
    advantages: ["متانة", "سهولة التركيب", "صيانة قليلة", "جمالية"],
    image: "https://images.pexels.com/photos/236709/pexels-photo-236709.jpeg"
  }
];

export const engineeringOffice = {
  title: "مكتب دراسات متكامل في خدمتكم",
  subtitle: "بريباتي ترافق مشاريعكم منذ مرحلة التصميم",
  description: "يرافقكم مكتب الدراسات لدينا لتحسين أرضياتكم وضمان المطابقة التقنية لمنشآتكم. من التصميم إلى التنفيذ، استفيدوا من دعم تقني متخصص.",
  services: [
    {
      title: "تحديد أبعاد الأرضيات",
      description: "حساب دقيق لمقاطع الكمرات حسب الأحمال والامتدادات لمشروعكم."
    },
    {
      title: "حسابات الأحمال والامتدادات",
      description: "تحليل الإجهادات وتحسين الحلول الإنشائية."
    },
    {
      title: "تحسين المقاطع",
      description: "تقليل التكاليف مع الحفاظ على الأداء المطلوب."
    },
    {
      title: "مساعدة تقنية",
      description: "مرافقة المهندسين ومكاتب المراقبة طوال المشروع."
    }
  ],
  image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/l0pq16qh_ChatGPT%20Image%20Jan%2014%2C%202026%2C%2001_52_09%20AM.png"
};

export const comparisonData = {
  title: "البناء التقليدي أم الحل الصناعي؟",
  subtitle: "قارن واختر الخيار الأفضل لمشروعك",
  criteria: [
    {
      aspect: "القوالب",
      traditional: "قوالب خشبية في الموقع، تستهلك الوقت واليد العاملة",
      prebati: "لا حاجة للقوالب - تركيب مباشر للكمرات والبلاطات"
    },
    {
      aspect: "اليد العاملة",
      traditional: "فريق كبير مطلوب، مهارات متنوعة ضرورية",
      prebati: "فريق مختصر، تدريب سريع على التنفيذ"
    },
    {
      aspect: "المواعيد",
      traditional: "مواعيد طويلة للقوالب والتسليح والصب وفك القوالب",
      prebati: "تنفيذ سريع، توفير كبير في الوقت بالموقع"
    },
    {
      aspect: "الجودة",
      traditional: "متغيرة حسب ظروف الموقع واليد العاملة",
      prebati: "ثابتة - إنتاج صناعي مراقب في المصنع"
    },
    {
      aspect: "مخاطر الخطأ",
      traditional: "عالية - تعتمد على التنفيذ في الموقع",
      prebati: "ضئيلة - عناصر مسبقة الصنع بأبعاد دقيقة"
    },
    {
      aspect: "الامتدادات الممكنة",
      traditional: "محدودة بتعقيد التسليح",
      prebati: "حتى 9-10 أمتار بفضل الإجهاد المسبق"
    }
  ]
};

export const qualityContent = {
  title: "الجودة والمطابقة",
  subtitle: "التزام بالجودة في كل مرحلة من الإنتاج",
  description: "تلتزم بريباتي بتسليم منتجات مطابقة لأعلى المعايير. عملية مراقبة الجودة لدينا تضمن التتبع والموثوقية لكل عنصر منتج.",
  steps: [
    {
      title: "اختيار المواد الأولية",
      description: "ركام وأسمنت وفولاذ مختارة وفق معايير جودة صارمة."
    },
    {
      title: "مراقبة الخرسانة",
      description: "اختبارات منتظمة لمقاومة واتساق الخرسانة الطازجة."
    },
    {
      title: "إشراف على التصنيع",
      description: "متابعة صارمة لكل مرحلة من عملية الإنتاج."
    },
    {
      title: "فحص المنتجات النهائية",
      description: "مراقبة أبعاد وبصرية لكل عنصر قبل التخزين."
    }
  ],
  certifications: [
    "مطابقة للمعايير الفرنسية",
    "مطابقة للمعايير الأوروبية",
    "تتبع كامل للدفعات",
    "ترخيص OTEP فرنسا"
  ],
  image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/azffbzbe__50A7317.JPG"
};

export const articles = [
  {
    id: "quest-ce-que-le-beton-precontraint",
    title: "ما هي الخرسانة سابقة الإجهاد؟",
    excerpt: "اكتشف المبادئ الأساسية للخرسانة سابقة الإجهاد وكيف تُحدث هذه التقنية ثورة في البناء الحديث.",
    content: "الخرسانة سابقة الإجهاد هي تقنية بناء تتضمن وضع الخرسانة تحت ضغط دائم قبل استخدامها...",
    date: "2025-01-15",
    readTime: "5 دقائق",
    category: "تقنية"
  },
  {
    id: "beton-precontraint-vs-beton-arme",
    title: "الخرسانة سابقة الإجهاد مقابل الخرسانة المسلحة",
    excerpt: "مقارنة تفصيلية بين هاتين التقنيتين: المزايا والعيوب وحالات الاستخدام الموصى بها.",
    content: "الخرسانة المسلحة والخرسانة سابقة الإجهاد تقنيتان متكاملتان لكن مختلفتان...",
    date: "2025-02-10",
    readTime: "7 دقائق",
    category: "مقارنة"
  },
  {
    id: "pourquoi-choisir-plancher-industriel",
    title: "لماذا تختار أرضية صناعية؟",
    excerpt: "المزايا الاقتصادية والتقنية للأرضيات المسبقة الصنع مقارنة بالحلول المصبوبة في الموقع.",
    content: "تقدم الأرضيات الصناعية المسبقة الصنع مزايا عديدة مقارنة بطرق البناء التقليدية...",
    date: "2025-03-05",
    readTime: "6 دقائق",
    category: "دليل عملي"
  },
  {
    id: "avantages-precontraint-climat-sahelien",
    title: "مزايا الإجهاد المسبق في المناخ الساحلي",
    excerpt: "كيف تستجيب الخرسانة سابقة الإجهاد للتحديات الخاصة بالبناء في موريتانيا والمنطقة الساحلية.",
    content: "يفرض المناخ الساحلي قيوداً خاصة على مواد البناء: حرارة شديدة، تفاوت حراري كبير، رياح رملية...",
    date: "2025-04-20",
    readTime: "8 دقائق",
    category: "محلي"
  }
];

export const navigationLinks = [
  { name: "الرئيسية", path: "/" },
  { name: "من نحن", path: "/about" },
  { name: "الخرسانة سابقة الإجهاد", path: "/prestressed-concrete" },
  { name: "المنتجات", path: "/products" },
  { name: "مكتب الدراسات", path: "/engineering" },
  { name: "المقارنة", path: "/comparison" },
  { name: "الجودة", path: "/quality" },
  { name: "المقالات", path: "/articles" }
];

// UI Translations
export const ui = {
  requestQuote: "طلب عرض سعر",
  discoverSolutions: "اكتشف حلولنا",
  learnMore: "اقرأ المزيد",
  readArticle: "قراءة المقال",
  readTime: "قراءة",
  ourProducts: "منتجاتنا",
  product: "منتج",
  characteristics: "الخصائص",
  applications: "التطبيقات",
  advantages: "المزايا",
  process: "العملية",
  services: "الخدمات",
  methodology: "المنهجية",
  comparison: "مقارنة",
  traditionalMethod: "الطريقة التقليدية",
  prebatiSolution: "حل بريباتي",
  qualityProcess: "عملية الجودة",
  conformity: "المطابقة",
  resources: "الموارد",
  stayInformed: "ابق على اطلاع",
  navigation: "التنقل",
  contactUs: "اتصل بنا",
  allRightsReserved: "جميع الحقوق محفوظة",
  firstFactory: "أول مصنع موريتاني لأرضيات الخرسانة سابقة الإجهاد",
  underLicense: "بترخيص OTEP فرنسا",
  phoneWhatsApp: "هاتف / واتساب",
  email: "البريد الإلكتروني",
  location: "الموقع",
  maxSpan: "الامتداد الأقصى",
  license: "ترخيص فرنسا",
  firstIn: "الأولى في موريتانيا",
  localProduction: "تصنيع محلي",
  whyPrebati: "لماذا بريباتي",
  referenceInMauritania: "مرجع الخرسانة سابقة الإجهاد في موريتانيا",
  industrialProduction: "إنتاج صناعي",
  europeanStandards: "معايير أوروبية",
  integratedEngineering: "مكتب دراسات متكامل",
  localManufacturing: "تصنيع محلي",
  readyToBuild: "مستعد للبناء مع بريباتي؟",
  contactTeam: "تواصل مع فريقنا لمناقشة مشروعك والحصول على عرض سعر مخصص.",
  freeQuote: "طلب عرض سعر مجاني",
  haveProject: "لديك مشروع بناء؟",
  discoverHow: "اكتشف كيف يمكن لبريباتي مرافقتك.",
  partnership: "شراكة",
  strategicCollaboration: "تعاون استراتيجي",
  ourObjectives: "أهدافنا",
  ourPositioning: "موقعنا",
  controlAtEveryStep: "مراقبة في كل مرحلة",
  certificationsCommitments: "شهاداتنا والتزاماتنا",
  completeTraceability: "تتبع كامل",
  qualityAtService: "الجودة في خدمة مشاريعكم",
  ourProductsLink: "منتجاتنا",
  convincedBySolution: "مقتنع بالحل الصناعي؟",
  askQuoteForProject: "اطلب عرض سعر لمشروعك القادم.",
  traditionalConstruction: "البناء التقليدي",
  prebatiSolutionTitle: "حل بريباتي",
  projectToStudy: "مشروع للدراسة؟",
  engineeringAtService: "مكتب الدراسات في خدمتكم.",
  requestStudy: "طلب دراسة",
  howWeWork: "كيف نعمل معكم",
  study: "دراسة",
  calculations: "حسابات",
  plans: "مخططات",
  followUp: "متابعة",
  studyDesc: "تحليل مخططاتكم واحتياجاتكم الخاصة",
  calculationsDesc: "تحديد أبعاد وتحسين الأرضيات",
  plansDesc: "مخططات التركيب والوثائق التقنية",
  followUpDesc: "مرافقة حتى الموقع",
  deepenKnowledge: "تعميق معرفتك",
  consultArticles: "اطلع على مقالاتنا لمعرفة المزيد عن الخرسانة سابقة الإجهاد.",
  readOurArticles: "قراءة مقالاتنا",
  learnMoreAboutPrestressed: "معرفة المزيد عن الخرسانة سابقة الإجهاد",
  comparisonTeaser: "الخرسانة سابقة الإجهاد مقابل البناء التقليدي",
  discoverWhyBetter: "اكتشف لماذا الإجهاد المسبق أكثر فائدة.",
  seeComparison: "مشاهدة المقارنة",
  benefitsOfPrestressed: "فوائد الخرسانة سابقة الإجهاد",
  needSpecificProduct: "تحتاج منتجاً محدداً؟",
  teamAvailable: "فريقنا متاح لدراسة احتياجاتكم واقتراح أفضل حل.",
  learnMoreAboutPrebati: "معرفة المزيد عن بريباتي",
  responseTime: "فريقنا يرد خلال 24 ساعة عمل."
};
